import type { Move } from "../../../../royalur/model/Move.js";
import type { Engine } from "../../../../royalur/engine/Engine.js";
import { BoardDirective } from "./BoardDirective.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import type { GameState } from "../../../../royalur/engine/state/GameState.js";


/**
 * A directive for rendering the dice.
 */
export class MoveBoardDirective extends BoardDirective {
    readonly state: GameState;
    readonly move: Move;
    readonly moveWinsGame: boolean;
    readonly isGameWon: boolean;

    constructor(
        directiveID: number,
        rules: Engine,
        moveIndex: number,
        state: GameState,
        move: Move,
        moveWinsGame: boolean,
        isGameWon: boolean,
    ) {
        super(directiveID, rules, moveIndex);
        this.state = state;
        this.move = move;
        this.moveWinsGame = moveWinsGame;
        this.isGameWon = isGameWon;
    }

    isLimboDirective(): boolean {
        return false;
    }

    override getState(): GameState {
        return this.state;
    }

    override getActivePlayer(): PlayerType {
        return this.move.getPlayer();
    }
}
